import axios from "axios";

export const BASE_URL = process.env.REACT_APP_COMMUNITY_BASE_URL;
// console.log("IAM BASEURL", BASE_URL);
// export const BASE_URL = 'https://58e3-122-166-248-97.ngrok-free.app';

const API_KEY = process.env.REACT_APP_COMMUNITY_API_KEY;

// Utility to create Axios instances with default headers
const createAxiosInstance = (contentType) => {
  const instance = axios.create({
    baseURL: BASE_URL,
    headers: {
      "Content-Type": contentType,
      "x-api-key": API_KEY,
    },
  });

  instance.interceptors.request.use(
    async (config) => {
      // Preserve any manually set Authorization header
      if (!config.headers.Authorization) {
        const token = await localStorage.getItem("objectId");
        if (token) {
          config.headers.Authorization = `Bearer ${token}`;
        }
      }
      return config;
    },
    (error) => Promise.reject(error)
  );

  return instance;
};

// Attach response interceptors to handle errors globally
const attachResponseInterceptors = (instance) => {
  instance.interceptors.response.use(
    (response) => response,
    (error) => {
      if (!error.response) {
        console.error("Network Error: No response from server.");
        return Promise.reject(
          new Error("Network Error: No response from server.")
        );
      }

      const responseError = error.response.data;

      console.error("API Error:", responseError);
      return Promise.reject(responseError);
    }
  );
};

export const API = createAxiosInstance("application/json");
export const APIFORMDATA = createAxiosInstance("multipart/form-data");
export const APIOTHERS = createAxiosInstance("application/json");
export const APIOTHERSFORMDATA = createAxiosInstance("multipart/form-data");

[API, APIFORMDATA, APIOTHERS, APIOTHERSFORMDATA].forEach(
  attachResponseInterceptors
);
